module.exports = __webpack_public_path__ + "static/media/user.c878c47d.png";